import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Close from '@mui/icons-material/Close';
import ErrorOutline from '@mui/icons-material/ErrorOutline';

export const ErrorIconCell = (params) => {
  const row = params.data || {};
  const text = (row && (row.error_label || row.error)) || '';
  const t = params.t;
  if (!text) return <span className="mcc-campaign-error-empty">—</span>;
  const stop = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <IconButton
      size="small"
      className="mcc-campaign-error-btn"
      title={
        (t &&
          t('Campaigns.ViewError', { defaultValue: 'View error details' })) ||
        'View error details'
      }
      aria-label={
        (t &&
          t('Campaigns.ViewError', { defaultValue: 'View error details' })) ||
        'View error details'
      }
      onClick={(event) => {
        stop(event);
        if (typeof params.onViewError === 'function') params.onViewError(row);
      }}
    >
      <ErrorOutline fontSize="small" />
    </IconButton>
  );
};

const CampaignErrorDialog = ({ open, row, t, onClose }) => {
  const label = (key, fallback) =>
    (t && t(key, { defaultValue: fallback })) || fallback;
  const detail =
    (row && (row.error || row.error_label)) ||
    label(
      'Campaigns.ErrorUnknown',
      'The message was not delivered. No detailed provider error was stored for this send.'
    );
  const progress =
    (row && row.progress_label) ||
    `${(row && row.sent_count) || 0} / ${(row && row.skipped_count) || 0} / ${
      (row && row.recipient_count) || 0
    }`;
  return (
    <Dialog
      open={!!open && !!row}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="mcc-campaign-error-dialog"
    >
      <DialogTitle className="mcc-campaign-error-title">
        <span className="mcc-campaign-error-title-text">
          <ErrorOutline />
          {label('Campaigns.ErrorTitle', 'Campaign send error')}
        </span>
        <IconButton aria-label="Close" onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <dl className="mcc-campaign-error-meta">
          <div>
            <dt>{label('Campaigns.Name', 'Campaign name')}</dt>
            <dd>{(row && row.name) || '—'}</dd>
          </div>
          <div>
            <dt>{label('Campaigns.Location', 'Location')}</dt>
            <dd>{(row && row.location_name) || '—'}</dd>
          </div>
          <div>
            <dt>{label('Campaigns.Channel', 'Channel')}</dt>
            <dd>
              {(row && (row.channel_label || row.channel)) || '—'}
            </dd>
          </div>
          <div>
            <dt>{label('Campaigns.Status', 'Status')}</dt>
            <dd>
              {(row &&
                (row.status_label || row.outcome_label || row.status)) ||
                '—'}
            </dd>
          </div>
          <div>
            <dt>
              {label('Campaigns.RecipientsCol', 'Sent / recipients')}
            </dt>
            <dd>{progress}</dd>
          </div>
        </dl>
        <p className="mcc-campaign-error-heading">
          {label('Campaigns.Error', 'Error')}
        </p>
        <pre className="mcc-campaign-error-detail">{detail}</pre>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ textTransform: 'none' }}>
          {label('MessageControl.Close', 'Close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CampaignErrorDialog;



// WEBPACK FOOTER //
// ./src/components/campaigns/CampaignErrorDialog.js